<template>
	<v-sheet>
		<h2 class="mb-6 primary--text cn-font">Impressum</h2>
		<p>
			CHECK IT NOW ist eine Marke der bvitg Service GmbH Friedrichstraße 200 10117 Berlin
		</p>
			
		<p>Telefon</p>
		<p>
			+49 30 206 22 58 – 20<br/>
			info@bvitg-service.de
		</p>
		<p>
			Geschäftsführer
		</p>
		<p>
			Sebastian Zilch
		</p>
		<p>
			Amtsgericht<br/>
			Berlin-Charlottenburg Handelsregister B<br/>
			99852 B			
		</p>

		<p>
			St.-Nr. 30/248/50127<br/>
			U-St.-Id-Nr. DE 814601437
		</p>
		<p>
			Verantwortlich für den Inhalt (gem. § 55 Abs. 2 RStV):<br/>
			Sebastian Zilch
		</p>
		<p>
			Online-Redaktion:<br/>
			Timo Bayer, Valentin Willaredt
		</p>
		<p>
			Die CHECK IT NOW-Website enthält Links, die auf Internetseiten anderer Anbieter verweisen. Trotz sorgfältiger inhaltlicher Kontrolle übernimmt die bvitg Service GmbH keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich. Weitere Informationen erhalten Sie in unserer Datenschutzerklärung.
		</p>
		<p>
			Website-Gestaltung und-Produktion:
		</p>
		<p>
			<a href="mikalo.studio">
				MIKALO, Studio für Marken und Gestaltung
			</a><br/>
			<a href="fait.de">fait.de</a>
		</p>
		<p>
			Quelle Datenschutz/Impressum:<br/>
			<a href="https://www.e-recht24.de/muster-datenschutzerklaerung.html"> https://www.e-recht24.de/muster-datenschutzerklaerung.html</a>
			
		</p>
		<p>
			Bildnachweis: <a href="www.istock.com">www.istock.com</a>, <a href="www.pexels.com">www.pexels.com</a>
		</p>
		<p>
			Stand: 12.08.2020
		</p>
		<h2 class="cn-font primary--text mt-3">
			Datenschutzerklärung
		</h2>
		<p>
			Wir freuen uns über Ihr Ihren Besuch auf unserer Webseite sowie Ihrem Interesse an den Fort- und Weiterbildungsthemen von CHECK IT NOW. Den Schutz Ihrer persönlichen Daten und deren Sicherheit nehmen wir sehr ernst. Aus diesem Grund erhebt und verarbeitet unsere Webseite möglichst wenig personenbezogene Daten. Alle erhobenen, personenbezogenen Daten behandeln wir vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung. Im Folgenden informieren wir Sie darüber, welche Daten während Ihres Besuchs auf der Webseite www.dmea-sparks.de erfasst und welche Teile dieser Informationen in welcher Form genutzt und verarbeitet werden.
		</p>
		<p>
			Die bvitg Service GmbH, Friedrichstraße 200, 10117 Berlin ist Anbieterin und verantwortliche Stelle im Sinne des Datenschutzrechts.
		</p>

		<h2 class="cn-font primary--text mt-3">
			Wie werden Ihre Daten erhoben?
		</h2>
		<p>
			Im Rahmen des Betriebs unserer Website werden automatisch Informationen in so genannten Server-Log Files erhoben und gespeichert, die Ihr Browser automatisch an uns übermittelt. Alle weiteren Daten werden durch Ihre aktive Eingabe erfasst.
		</p>
		<h2 class="cn-font primary--text mt-3">
			Wozu werden Ihre Daten verwendet?
		</h2>
		<p>
			Um unser Webangebot angemessen und zuverlässig bereitstellen zu können sowie zur Optimierung und zum Schutz unserer Webseite. Ihre Einwilligung vorausgesetzt verwenden wir Ihre Eingaben zudem, um auf entsprechende Kontaktanfragen und/oder Nachrichten zu reagieren. Eine Weitergabe Ihrer Daten an Dritte erfolgt nur in besonderen Ausnahmefällen erfolgt, z.B. zur strafrechtlichen Verfolgung bei Missbrauch oder Angriff auf unsere IT-Systeme.
		</p>

		<h2 class="cn-font primary--text mt-3"> Welche Daten erfassen wir von Ihnen, wenn Sie diese Seite aufrufen und Nutzen?</h2>
		<ul>
			<li>IP-Adresse</li>
			<li>Zeitstempel des Besuchs</li>
			<li>abgefragte Ressource</li>
			<li>Status</li>
			<li>übertragene Datenmenge</li>
			<li>Dauer der Datenübertragung</li>
			<li>Herkunft Ihres Seitenaufrufes</li>
			<li>Name der Browsersoftware</li>
			<li>Version der Browsersoftware</li>
		</ul>
		<h2 class="cn-font primary--text mt-3"> 
			Folgende Rechte haben Sie als Besucher unserer Webseite
		</h2>
		<h3 class="cn-font grey--text mt-3">
			Vervollständigung
		</h3>
		<p>
			Sie haben das Recht, die Vervollständigung der Sie betreffenden Daten oder die Berichtigung der Sie betreffenden unrichtigen Daten zu verlangen (Art. 16 DSGVO).
		</p>
		<h3 class="cn-font grey--text mt-3">
			Löschung
		</h3>
		<p>
			Sie haben das Recht zu verlangen, dass Sie betreffende Daten unverzüglich gelöscht werden (Art. 17 DSGVO), oder alternativ eine Verarbeitungseinschränkung Ihrer Daten zu verlangen (Art. 18 DSGVO), sofern diese Daten für andere gesetzlich zulässige Zwecke erforderlich sind.
		</p>
		<h3 class="cn-font grey--text mt-3">Übermittlung
		</h3>
		<p>
			
			Sie haben das Recht zu verlangen, dass Sie betreffende Daten, die Sie uns bereitgestellt haben zu erhalten oder deren Übermittlung an andere Verantwortliche zu fordern.
		</p>

		<h3 class="cn-font grey--text mt-3">	Beschwerde
		</h3>
		<p>
			Sie haben das Recht, eine Beschwerde bei der zuständigen Aufsichtsbehörde einzureichen (Art. 77 DSGVO) Berliner Beauftragte für Datenschutz und Informationsfreiheit datenschutz-berlin.de
		</p>



	<h2 class="cn-font primary--text mt-3"> Widerruf</h2>
	<p>Sie haben das Recht, erteilte Einwilligungen zu widerrufen. Dies geschieht mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO).</p>

	<h2 class="cn-font primary--text mt-3"> Widerspruch</h2>
	<p>Sie haben das Recht, künftigen Verarbeitung der Sie betreffende Daten zu widersprechen (Art. 21 DSGVO). Dieser Widerspruch kann sich insbesondere gegen Direktwerbung richten, die diese Daten für Ihre Zwecke verarbeitet.</p>

	<h2 class="cn-font primary--text mt-3"> Einschränkung der Verarbeitung</h2>
	<p>Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen, soweit die Richtigkeit der Daten von Ihnen bestritten wird, die Verarbeitung unrechtmäßig ist, Sie aber deren Löschung ablehnen und wir die Daten nicht mehr benötigen, Sie jedoch diese zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen benötigen oder Sie gemäß Art. 21 DSGVO Widerspruch gegen die Verarbeitung eingelegt haben;</p>

	<h3 class="cn-font grey--text mt-3">Löschung von Daten</h3>
	<p>Von uns verbreitete Daten werden gelöscht, sobald diese für Ihre Zweckbestimmung nicht mehr erforderlich sind und keine gesonderten, gesetzlichen Aufbewahrungspflichten entgegenstehen. So ist zum Beispiel die Aufbewahrung von Eröffnungsbilanzen, Jahresabschlüsse für 6 Jahre (§ 257 Abs. 1 HGB) und für Buchungsbelege, oder für steuerrelevante Unterlagen 10 Jahre (§ 147 Abs. 1 AO) vorgesehen.</p>
	
	<h2 class="cn-font primary--text mt-3">Fragen an den Datenschutzbeauftragten</h2>
	<p>
		Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail an info@bvitg-serice.de oder wenden Sie sich direkt an unseren Datenschutzbeauftragten:
	</p>
	<p>
		CHECK IT NOW
	</p>
	<p>
		bvitg Service GmbH<br/>
		-Datenschutz-<br/>
		Friedrichstraße 200<br/>
		10117 Berlin
	</p>
	<p>
		Generell ist die Geltendmachung Ihrer o. g. Rechte für Sie unentgeltlich.
	</p>
	<h2 class="cn-font primary--text mt-3">
		Zwecke und Umfang der Datenverarbeitung
	</h2>
	<p>Im Rahmen des Betriebs unserer Website werden automatisch Informationen in so genannten Server-Log Files erhoben und gespeichert, die Ihr Browser automatisch an uns übermittelt. Diese Daten sind nicht bestimmten Personen zuordenbar. Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Es werden keine Nutzungsprofile mittels dieser Daten angelegt.</p>
	<p>
		IP-Adressen speichern wir über einen von einer Woche in Server-Logfiles. Die Speicherung erfolgt aus Gründen der Datensicherheit, um die Stabilität und die Betriebssicherheit unseres Internetauftritts zu gewährleisten. Die Rechtsgrundlage hierfür sind Art. 6 Abs. 1 lit. c DS-GVO.
	</p>
	<p>
		Die IP-Adresse kann ein personenbezogenes Datum sein, weil es unter bestimmten Voraussetzungen möglich ist, damit durch Auskunft des jeweiligen Internetanbieters die Identität des Inhabers des genutzten Internetzugangs in Erfahrung zu bringen. Eine Auswertung der IP-Adresse ist unsererseits nicht vorgesehen. Dies könnte allenfalls dann relevant werden, wenn ein Angriff auf unser Internetsystem vorliegt. In diesem Fall haben wir ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 f) DS-GVO an der Verarbeitung der IP-Adresse. Es ergibt sich aus dem Bedürfnis, den Angriff auf unser Internetsystem abzuwehren, den Ursprung des Angriffs zu ermitteln, um gegen die verantwortliche Person straf- und zivilrechtlich vorgehen zu können sowie weiteren Angriffen effektiv vorzubeugen.
	</p>
	<h2 class="cn-font primary--text mt-3">Cookies</h2>
	<p>
		Die Internetseiten verwenden teilweise so genannte Cookies. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert. Die meisten der von uns verwendeten Cookies sind so genannte „Session-Cookies“. Sie werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Diese Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen. Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.
	</p>


<h2 class="cn-font primary--text mt-3">Analyse</h2>
<p>Auf unserer Webseite (www.chckit-now.de) haben wir einen Analysedienst eingebunden (Matomo). Über die Dienste werden Informationen über Ihren Besuch auf unserer Webseite erhoben, damit wir die Funktionalität unserer Webseite nachvollziehen und nutzerfreundlicher gestalten können. Die Datenverarbeitung erfolgt ausschließlich statistisch. Ihre IP-Adresse wird daher standardmäßig um das letzte Oktett gekürzt. so dass die zuvor personenbezogenen Nutzerdaten direkt anonymisiert werden und keine Zuordnung zu einem individuellen Nutzer erfolgen kann.</p>

Die Datenverarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch seine Werbung zu optimieren.

<h2 class="cn-font primary--text mt-3">Matomo</h2>
<p>Unsere Webseiten nutzen den Open Source Webanalysedienst Matomo. Hierbei verzichten wir auf die Erzeugung von Cookies. Die IP-Adresse wird vor der Speicherung anonymisiert. Es werden Daten zum Betriebssystem, Displayauflösung, Browserversion, Referrer auf unserem eigenen Server gespeichert.</p>
<p>
	Die erzeugten Informationen über die Benutzung unserer Webseiten werden nicht an Dritte weitergegeben. Sie können die Erfassung der Nutzerbewegung durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; aktiveren Sie die Do-Not-Track Funtion.
</p>

<h2 class="cn-font primary--text mt-3">Kontaktformulare</h2>
<p>Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage von uns verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. Wir löschen Ihre Daten, wenn der Zweck, zu dem Sie uns Ihre Daten mitgeteilt haben, erfüllt oder erledigt ist und wir nicht aus gesetzlichen Gründen zur weiteren Speicherung berechtigt oder verpflichtet sind.</p>

<h2 class="cn-font primary--text mt-3">Anmeldung zum Newsletter</h2>
<p>Wenn Sie den auf der Webseite angebotenen Newsletter erhalten möchten, benötigen wir von Ihnen eine E-Mail-Adresse sowie Informationen, welche uns die Überprüfung gestatten, dass Sie der Inhaber der angegebenen E-Mail-Adresse sind und mit dem Empfang der Info-Mails einverstanden sind (Double Opt-In). Weitere Daten werden nicht erhoben. Diese Daten verwenden wir ausschließlich für den Versand der angeforderten Informationen und geben sie nicht an Dritte weiter. Die erteilte Einwilligung zur Speicherung der Daten, der E-Mail-Adresse sowie deren Nutzung zum Versand der Informationen können Sie jederzeit widerrufen, über eine Mail an info@bvitg.de.</p>

<h2 class="cn-font primary--text mt-3">Allgemeine Information zu Applikationen anderer Anbieter</h2>
<p>Auf unseren Websites werden ggf. Inhalte von Drittanbietern, wie zum Beispiel Angebote von Google-Maps oder YouTube eingebunden. Hierfür ist technisch erforderlich, dass diese Drittanbieter die IP-Adresse der Nutzer verwenden, da ohne die IP-Adresse keine Inhalte an den Browser des Nutzers gesendet werden können. Wir bemühen uns, nur Inhalte von Drittanbietern einzubinden, die IP-Adressen lediglich zur Auslieferung der Inhalte verwenden. Wir haben jedoch keinen Einfluss darauf, ob Drittanbieter IP-Adressen für andere Zwecke verarbeiten, zum Beispiel für statistische Zwecke. Die Applikationen werden auf den Servern der Drittanbieter gehostet und von diesen Drittanbietern betrieben. Bitte beachten Sie, dass die Nutzung einer solchen Applikation der dort hinterlegten Datenschutzbestimmung des jeweiligen Drittanbieters unterliegt, der für diese Verarbeitung Verantwortlicher im Sinne des Art. 4 Nr.7 DS-GVO ist.</p>

<h2 class="cn-font primary--text mt-3">SSL-Verschlüsselung</h2>
<p>Diese Seite nutzt aus Gründen der Sicherheit und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel der Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://“ auf „https://“ wechselt und an dem Schloss-Symbol in Ihrer Browserzeile. Wenn die SSL Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.</p>

<h2 class="cn-font primary--text mt-3">Empfänger von Daten</h2>
<p>Sofern im Einzelfall Dienstleister von uns eingesetzt werden, stellen wir durch Verträge und Kontrollen sicher, dass die Datensicherheit und der Datenschutz bei den Dienstleistern gewährleistet sind. Hierzu zählen folgende Kategorien von Auftragnehmern: Softwareentwickler, Hoster von Servern, Newsletterversender, Kundensupport, Webanalysedienst.</p>

<h2 class="cn-font primary--text mt-3">Ihre Rechte als Besucher unserer Webseite</h2>
<p>Nach Maßgabe der gesetzlichen Vorschriften haben Sie als Betroffener das Recht, jederzeit unentgeltlich Auskunft über Ihre, bei uns gespeicherten Daten zu erhalten. Darüber hinaus können Sie Ihre Rechte auf Berichtigung, Löschung oder Einschränkung der Verarbeitung oder das Recht auf Widerspruch jederzeit gegenüber uns geltend machen. Dies gilt auch für ein Recht auf Datenübertragbarkeit. Sollten Sie uns Ihre personenbezogenen Daten auf Basis einer Einwilligung zur Verfügung gestellt haben, könnten Sie die Einwilligung jederzeit für die Zukunft widerrufen. Die Geltendmachung Ihrer Rechte ist für Sie unentgeltlich. Bitte wenden Sie sich dazu an unseren Ansprechpartner für den Datenschutz: info@bvitg-service.de oder per Post:</p>

<p>CHECK IT NOW</p>
<p>	
	bvitg Service GmbH<br/>
	-Datenschutz-<br/>
	Friedrichstraße 200<br/>
	10117 Berlin
</p>

<h2 class="cn-font primary--text mt-3">Aufsichtsbehörde</h2>

<p>
	Sofern Sie der Ansicht sind, dass die Verarbeitung ihrer personenbezogenen Daten durch uns nicht rechtmäßig erfolgt, können Sie sich mit Ihrer Beschwerde an jede Datenschutz-Aufsichtsbehörde wenden. Die für uns örtlich zuständige Aufsichtsbehörde ist der
</p>

<p>
Berliner Beauftragte für Datenschutz und Informationsfreiheit<br/>
Friedrichstr. 219<br/>
10969 Berlin
</p>

<p>Telefon: 030 13889-0<br/>
Telefax: 030 2155050</p>
<p>	
E-Mail: mailbox@datenschutz-berlin.de<br/>
Webseite: datenschutz-berlin.de
</p>

<h2 class="cn-font primary--text mt-3">Aktualisierung dieser Datenschutzerklärung</h2>
Von Zeit zu Zeit kann eine Aktualisierung dieser Datenschutzhinweise notwendig werden, beispielsweise durch neue oder veränderte Angebote auf unserer Internetpräsenz oder gesetzliche Änderungen. Die aktuelle Fassung finden Sie an dieser Stelle. Generell empfehlen wir, dass Sie diese Datenschutzhinweise regelmäßig aufrufen, um zu prüfen, ob es hier Änderungen gab. Sie erkennen dies unter anderem an dem Datum der letzten Änderung, das am Ende dieses Dokuments angegeben ist.

<h2 class="cn-font primary--text mt-3">Ausdrucken und Abspeichern dieser Datenschutzhinweise</h2>
<p>
	
	Diese Datenschutzhinweise können Sie unmittelbar ausdrucken und abspeichern, beispielsweise durch die Druck- bzw. Speicherfunktion in Ihrem Browser.
</p>
<p>
	
Stand: 12.08.2020
</p>
</v-sheet>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "", 
		props: {
			
		},
		data: () => {
			return {

			}
		},
		// components: {

		// },
		// computed: {
			// ...Vuex.mapState({})
		// },
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>"